<template>
  <div class="page">
    <wap-header :isShow.sync="isShow" :isTransparent.sync="isTransparent"></wap-header>

    <div class="wap-home" @click="onHide">
      <img src="~@/assets/wap/home.jpg" />
      <div @click="$router.push({ path:'/wap-project' })">
        <img src="~@/assets/wap/home-01.png" />
      </div>
      <div @click="$router.push({ path:'/wap-product' })">
        <img src="~@/assets/wap/home-02.png" />
      </div>
      <div @click="$router.push({ path:'/wap-honor' })">
        <img src="~@/assets/wap/home-03.png" />
      </div>
    </div>
    <div class="icp" @click="onIcpJump">粤ICP备15070469号</div>
  </div>
</template>

<script>
import wapHeader from "@/components/wapHeader"

export default {
  metaInfo: {
    title: "东阳光冬虫夏草官网",
    meta: [
      {
        name: "keywords",
        content: "关键字"
      },
      {
        name: "description",
        content: "网页描述"
      }
    ]
  },
  components: {
    "wap-header": wapHeader
  },
  data() {
    return {
      isShow: false, // 是否显示
      isTransparent: false // 是否透明
    }
  },
  methods: {
    /**
     * 事件绑定 - 隐藏弹窗
     *
     * @return {void}
     */
    onHide () {
      this.isShow = false
    },

    /**
     * 事件绑定 - 点击备案号跳转
     *
     * @return {void}
     */
    onIcpJump() {
      window.location.href = "https://beian.miit.gov.cn"
    }
  }
}
</script>

<style scoped lang="stylus">
page {
  width: 100%;
  position: relative;
}

.wap-home {
  margin-top: -11%;

  div {
    width: 90%;
    margin: 0 auto;
  }

  img {
    width: 100%;
  }
}

.icp {
  color: #777;
  position: absolute;
  bottom: 20px;
  font-size: 16upx;
  width: 100%;
  text-align: center;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// wapHome.vue